import(/* webpackMode: "eager", webpackExports: ["VaultClient"] */ "/codebuild/output/src2220634010/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/vaults/[id]/VaultClient.tsx");
